<template>
    <div>
        <div class="assets-title">
            <div style="display: flex; align-items: center">
                <div class="title-line"></div>
                <span class="title-content">我的资产</span>
                <span class="deadline-text">截至日期 {{ date }}</span>
            </div>
            <div style="display: flex; align-items: center">
                <el-select v-model="sourceflag" placeholder="选择购买渠道" class="select-class">
                    <el-option
                        v-for="item in sourceflags"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                    ></el-option>
                </el-select>
                <div class="assets-search">
                    <el-autocomplete
                        v-model="searchText"
                        popper-class="my-autocomplete"
                        placeholder="请输入基金代码/名称"
                        class="input-search"
                        :fetch-suggestions="querySearchAsync"
                        v-on:select="handleSelect"
                    >
                        <template slot-scope="{ item }">
                            <div class="name">
                                {{ item.value }}
                            </div>
                        </template>
                        <el-button
                            slot="suffix"
                            icon="el-icon-search"
                            class="search-icon"
                            type="text"
                            size="small"
                            v-on:click="searchAssets"
                        />
                    </el-autocomplete>
                </div>
            </div>
        </div>
        <div class="assets-info">
            <div
                v-for="(item, index) in amountTypes"
                :key="index"
                class="assets-item"
                :style="{ width: $util.xjbIsOpen() ? (index == 0 ? '40%' : '25%') : '30%' }"
            >
                <div class="assets-item-singn">
                    <div class="amount-type">
                        {{ item.text }}
                        <span v-if="dataPromptShow && index != 0">
                            <el-tooltip
                                effect="dark"
                                content="当前收益为直销（每日0点更新）与代销（通常上午10点更新）数据的阶段性汇总，最终以双方数据完全同步后为准。"
                                placement="top-start"
                            >
                                <i
                                    class="el-icon-question"
                                    style="margin-left: 5px; color: var(--color-text-accent)"
                                ></i>
                            </el-tooltip>
                        </span>
                    </div>
                    <div v-if="index == 0" class="assets-text">
                        <span></span>
                        {{ $util.fmtNum(item.val) }}
                    </div>
                    <div
                        v-else
                        class="assets-text"
                        :class="item.val > 0 ? 'add' : item.val < 0 ? 'reduce' : ''"
                    >
                        {{ $util.fmtNum(item.val) }}
                    </div>
                </div>
                <div v-if="index === 0 && $util.xjbIsOpen()" class="vertical-divider"></div>
                <div v-if="index == 0 && $util.xjbIsOpen()" class="xjbAssets-item">
                    <span class="assets-text">
                        {{ $const.getXJBParam("name") }}{{ $util.fmtNum(item.xjbMarketvalue) }}
                    </span>
                </div>
            </div>
        </div>
        <div v-if="warnNum > 0 && $util.getConfig().hideFunc" class="warn-info">
            <i class="el-icon-warning warn-icon" aria-hidden="true" />
            <span class="warn-content">
                由于您的个人风险等级或产品风险等级变动，存在({{
                    warnNum
                }})笔产品风险等级高于您的风险承受能力的交易，请阅读风险警示进行适当性处理。
                <span class="warn-tip">
                    对于未处理的定期投资协议或预约交易，将不产生定投交易或预约交易申请。
                </span>
                <span class="deal-btn" v-on:click="toWarnDetail">前往处理</span>
            </span>
        </div>
        <!-- <div class="asset-type">
            <div
                v-for="(item, index) in assetsTypes"
                :key="index"
                :class="selectIndex == index ? 'type-select' : 'type-normal'"
                v-on:click="selectType(index)"
            >
                {{ item }}
            </div>
        </div> -->
        <el-row v-if="assets.length <= 0 && hasLoad && selectIndex != 3" class="no-funds">
            <el-col :span="12" :offset="8">
                <span class="no-funds-img" />
                <div class="no-funds-box">
                    <p>暂无数据</p>
                </div>
            </el-col>
        </el-row>
        <el-table
            v-else-if="hasLoad && selectIndex != 3"
            :data="assets"
            style="width: 100%"
            class="tab-list-tit"
            :header-cell-style="{ background: 'var(--bg-color-lightest)' }"
        >
            <el-table-column label="产品名称" width="280" class-name="fund-offset">
                <template slot-scope="scope">
                    <div class="fund-name" v-on:click.stop="gotoDetail(scope.row)">
                        <el-tooltip effect="info" :content="scope.row.fundname" placement="top">
                            <span>
                                {{ scope.row.fundname }}
                                <span v-if="scope.row.assetshowtype == '1'" class="xjbStyle">
                                    {{ $const.getXJBParam("name") }}
                                </span>
                            </span>
                        </el-tooltip>
                    </div>
                    <div style="display: flex; align-items: center">
                        <div>{{ scope.row.fundcode }}</div>
                        <div v-if="$util.hasFM(scope.row)" class="fm1">浮动管理费基金</div>
                    </div>
                </template>
            </el-table-column>
            <el-table-column label="持有份额(份)" align="center">
                <template slot-scope="scope">
                    <span>{{ $util.fmtNum(scope.row.currentshare) }}</span>
                </template>
            </el-table-column>
            <el-table-column align="center">
                <template slot="header">
                    <span>
                        {{
                            $cache.getCompanyInfoParam("5100004") == "1"
                                ? "市值(元)"
                                : "持仓市值(元)"
                        }}
                    </span>
                    <el-tooltip
                        v-if="$cache.getCompanyInfoParam('5100004') == '1'"
                        effect="dark"
                        content="市值=持仓市值+在途金额"
                        placement="top-start"
                    >
                        <i
                            class="el-icon-info"
                            style="margin-left: 5px; color: var(--color-text-accent)"
                        ></i>
                    </el-tooltip>
                </template>
                <template slot-scope="scope">
                    <span>{{ $util.fmtNum(scope.row.marketvalue) }}</span>
                </template>
            </el-table-column>
            <el-table-column align="center">
                <template slot="header">
                    <div>昨日收益</div>
                    <div>(元)</div>
                </template>
                <template slot-scope="scope">
                    <span
                        :class="
                            scope.row.lastprofit > 0
                                ? 'add'
                                : scope.row.lastprofit < 0
                                ? 'reduce'
                                : ''
                        "
                    >
                        {{ $util.fmtNum(scope.row.lastprofit) }}
                    </span>
                </template>
            </el-table-column>
            <el-table-column align="center">
                <template slot="header">
                    <div>持仓收益</div>
                    <div>(元)</div>
                </template>
                <template slot-scope="scope">
                    <span :class="getProfitClass(scope.row)">
                        {{ getProfitText(scope.row) }}
                    </span>
                </template>
            </el-table-column>
            <el-table-column label="操作" align="center" min-width="160">
                <template slot-scope="scope">
                    <div v-if="$util.getConfig().hideFunc" class="btns">
                        <el-tooltip
                            v-if="
                                (scope.row.assetshowtype === '1' ||
                                    xjbFundInfo.fundcode !== scope.row.fundcode) &&
                                scope.row.isBuy
                            "
                            class="item"
                            effect="info"
                            :content="
                                scope.row.isBuy +
                                '，不能' +
                                (scope.row.assetshowtype == '1'
                                    ? '充值'
                                    : scope.row.status == '1'
                                    ? '认购'
                                    : '申购')
                            "
                            placement="top"
                        >
                            <el-button disabled type="text" size="small">
                                {{
                                    scope.row.assetshowtype == "1"
                                        ? "充值"
                                        : scope.row.status == "1"
                                        ? "认购"
                                        : "申购"
                                }}
                            </el-button>
                        </el-tooltip>
                        <el-button
                            v-else-if="
                                scope.row.assetshowtype === '1' ||
                                xjbFundInfo.fundcode !== scope.row.fundcode
                            "
                            type="text"
                            plain
                            size="small"
                            v-on:click.stop="callbackFn('20,22', scope.row)"
                        >
                            {{
                                scope.row.assetshowtype == "1"
                                    ? "充值"
                                    : scope.row.status == "1"
                                    ? "认购"
                                    : "申购"
                            }}
                        </el-button>
                        <div
                            v-if="
                                scope.row.assetshowtype === '1' ||
                                xjbFundInfo.fundcode !== scope.row.fundcode
                            "
                            class="line"
                        ></div>
                        <el-tooltip
                            v-if="scope.row.isSell"
                            class="item"
                            effect="info"
                            :content="scope.row.isSell"
                            placement="top"
                        >
                            <el-button type="text" disabled size="small">
                                {{
                                    scope.row.assetshowtype == "1"
                                        ? "取现"
                                        : scope.row.bookingredeem == "1" ||
                                          scope.row.bookingredeem == "2"
                                        ? "预约赎回"
                                        : "赎回"
                                }}
                            </el-button>
                        </el-tooltip>
                        <el-button
                            v-else-if="
                                scope.row.bookingredeem == '1' || scope.row.bookingredeem == '2'
                            "
                            type="text"
                            plain
                            size="small"
                            v-on:click.stop="callbackFn('25', scope.row)"
                        >
                            预约赎回
                        </el-button>
                        <el-button
                            v-else
                            type="text"
                            plain
                            size="small"
                            :disabled="xjbFundInfo.fundcode === scope.row.fundcode && Number(scope.row.usableremainshare) <= 0"
                            v-on:click.stop="callbackFn('24', scope.row)"
                        >
                            {{ xjbFundInfo.fundcode !== scope.row.fundcode ? "赎回" : "取现" }}
                        </el-button>
                        <!-- <div v-if="scope.row.sourceflag != '2'" class="line"></div> -->
                        <div class="line"></div>
                        <!-- <div v-if="!(scope.row.fundArr.every((item) => item.sourceflag === '2'))" class="line"></div> -->
                        <el-button
                            type="text"
                            plain
                            size="small"
                            v-on:click.stop="showDetail(scope.row)"
                        >
                            详情
                        </el-button>
                    </div>
                    <div v-else>
                        <el-button
                            type="text"
                            plain
                            size="small"
                            v-on:click.stop="showDetail(scope.row)"
                        >
                            详情
                        </el-button>
                    </div>
                </template>
            </el-table-column>
        </el-table>
        <el-row v-if="allPage > 0 && selectIndex != 3" class="page-box">
            <el-pagination
                :page-size="Number(conf.PAGE_SIZE)"
                :current-page.sync="curPage"
                layout="->, total, prev, pager, next"
                :total="Number(allPage)"
                v-on:current-change="newAssets"
            />
        </el-row>
        <combo-assets v-show="selectIndex == 3" ref="comboAssets" :showhead="false"></combo-assets>
        <my-dialog
            title="提示"
            :visible.sync="warnVisible"
            :dialog-close="dialogClose"
            width="600px"
            :show-close="showclose"
        >
            <div class="warn-detail">
                由于您的个人风险等级或产品风险等级变动，存在({{
                    warnNum
                }})笔产品风险等级高于您的风险承受能力的交易，请前往进行适当性处理。
            </div>
            <div class="align-c">
                <el-button type="primary" style="width: 180px" v-on:click="toWarnDetail">
                    确认
                </el-button>
            </div>
        </my-dialog>
        <fund-sdx-dialog
            :fund="sdxFundInfo"
            :sdx-dialog-visible="sdxDialogVisible"
            v-on:dialogClosed="sdxDialogClose"
            v-on:dialogContinue="sdxDialogContinue"
        ></fund-sdx-dialog>
        <my-dialog
            title="提示"
            :visible.sync="bankCardVisible"
            :dialog-close="bankCardListClose"
            width="600px"
        >
            <div class="warn-detail">
                您所持有的银行卡有{{
                    bankCardNum
                }}张正处于“待激活"状态，为了使您的交易不受影响，点击确认，一键完成“激活”。
            </div>
            <div class="align-c">
                <el-button type="primary" style="width: 180px" v-on:click="bankCardListHandle">
                    确认
                </el-button>
            </div>
        </my-dialog>
        <my-dialog
            title="提示"
            :visible.sync="idCardHolderVisible"
            :dialog-close="idCardHolderClose"
            :show-close="false"
            width="600px"
        >
            <div class="warn-detail">
                尊敬的客户：您在系统中的身份证号为15位，
                <br />
                为保证您的正常使用请升级为18位！
            </div>
            <div class="align-c">
                <el-button type="primary" style="width: 180px" v-on:click="idCardHolderHandle">
                    确认
                </el-button>
            </div>
        </my-dialog>
        <my-dialog
            title="提示"
            :visible.sync="idCardHolderCompletedVisible"
            :dialog-close="idCardHolderCompletedClose"
            width="600px"
        >
            <div class="warn-detail">
                尊敬的用户您好：您已成功升级身份证，请确保银行卡绑定身份证与系统身份证位数一致，否则无法进行交易！
            </div>
            <div class="align-c">
                <el-button
                    type="primary"
                    style="width: 180px"
                    v-on:click="idCardHolderCompletedHandle"
                >
                    确认
                </el-button>
            </div>
        </my-dialog>

        <my-dialog
            title="提示"
            :visible.sync="appropriateHandlingVisible"
            :dialog-close="appropriateHandlingVisibleClose"
            :show-close="showclose"
            width="800px"
        >
            <warn-list
                :title-visible="false"
                :show-close="showclose"
                v-on:read-risk-all="appropriateHandlingVisibleClose"
                v-on:close-dialog="handleCloseDialog"
            />
        </my-dialog>
        <ocr-upd-dialog
            :visible="ocrShow"
            :cert-type="'00'"
            :checkflag="'0'"
            v-on="{ success: imgUp, back: regression }"
        />
    </div>
</template>

<script>
import mixin from "@/assets/js/mixin";
import fundApi from "@/api/fund";
import userApi from "@/api/user";
import format from "date-fns/format";
import myDialog from "@/components/layout/myDialog.vue";
import comboAssets from "@/components/fund/comboAssets.vue";
import fundSdxDialog from "@/components/form/fundSdxDialog";
import WarnList from "@/bizcomponents/assetShow/warnList.vue";
import ocrUpdDialog from "@/components/form/ocrUpdDialog.vue";

export default {
    name: "MyAssets",
    components: { WarnList, myDialog, comboAssets, fundSdxDialog, ocrUpdDialog },
    mixins: [mixin],
    data() {
        return {
            conf: {}, // 初始化配置文件内容
            searchText: "", // 搜索文本内容
            allAssets: {}, // 资产汇总信息
            assets: [], // 资产列表
            warnNum: 0, // 待处理数量
            warnVisible: false, // 适当性弹窗是否显示
            queryFind: null, // 定时器
            allPage: "0", // 所有数据条数
            pagecount: 10, // 分页条数
            pageoffset: 1, // 起始页
            amountTypes: [
                {
                    text: "资产总计(元)",
                    val: "",
                    xjbMarketvalue: ""
                },
                {
                    text: "最新收益(元)",
                    val: ""
                },
                {
                    text: "累计收益(元)",
                    val: ""
                }
            ], // 金额类型
            assetsTypes: ["全部", this.$const.getXJBParam("name"), "基金资产", "资产组合"],
            sourceflag: null, // 购买渠道
            sourceflags: [
                {
                    label: "全部购买渠道",
                    value: ""
                },
                {
                    label: "直销",
                    value: "1"
                },
                {
                    label: "代销",
                    value: "2"
                }
            ], // 购买渠道列表
            selectIndex: 0, // 选中资产类型下标
            curPage: 1, // 当前页
            date: "", // 当前日期
            hasLoad: false, // 是否已经查询数据
            assetshowtype: 0,
            sdxFundInfo: {},
            sdxDialogVisible: false,
            // 银行卡
            bankCardVisible: false,
            bankCardNum: 0,
            // 身份证生位
            idCardHolderVisible: false,
            // 身份证生位完成
            idCardHolderCompletedVisible: false,
            xjbFundInfo: {},
            appropriateHandlingVisible: false,
            dataPromptShow: false, // 收益字段旁提示
            ocrShow: false,
            isShowPositionProfit: true, //货币基金是否展示持仓收益
            showclose: true, // 是否展示风险不匹配弹框关闭按钮，默认开启
            showprofitexplain: true // 脚本控制是否显示小问号
        };
    },
    watch: {
        searchText(val, from) {
            if (from.length > 0 && val == "") {
                this.searchAssets();
            }
        },
        sourceflag(val, from) {
            this.pageoffset = 1;
            this.doAction();
        },
        allPage() {
            this.curPage = 1;
        }
    },
    mounted() {
        this.conf = this.$util.getConfig().const;
        this.date = this.$util.fmtDate(format(new Date(), "YYYYMMDD"));

        const accountInfo = this.$cache.getParamValue("account_info");
        let risk = accountInfo && accountInfo.promptoptions && accountInfo.promptoptions.risk;

        if (risk && risk.showclose !== undefined) {
            this.showclose = risk.showclose;
        }

        const assetInfo = this.$cache.getParamValue("asset_info");
        this.showprofitexplain = !(assetInfo && assetInfo.showprofitexplain === false);

        this.doAction();
        if (this.$cache.getBinded()) {
            this.getSuitableList();
            userApi.getBankCardList().then(({ bankList }) => this.bankCardListCheck(bankList));
        }
        this.idCardHolderCheck();
        // 有配置回访问卷地址才走此逻辑
        this.$cache.getCompanyInfoParam("10102036") && this.openReturnVisit();
        this.xjbFundInfo = JSON.parse(sessionStorage.getItem("xjbFundInfo")) || {};
        this.isShowPositionProfit = this.$util.isShowPositionProfit();
    },
    methods: {
        // 获取持仓收益样式类
        getProfitClass(row) {
            // 不显示持仓收益且为货币基金时，无样式
            if (!this.isShowPositionProfit && row.fundshowtype === '5') {
                return '';
            }
            // 其他情况根据收益值判断样式
            return row.currentprofit > 0 ? 'add' : row.currentprofit < 0 ? 'reduce' : '';
        },
        // 获取持仓收益显示文本
        getProfitText(row) {
            // 不显示持仓收益且为货币基金时，显示--
            if (!this.isShowPositionProfit && row.fundshowtype === '5') {
                return '--';
            }
            return this.$util.fmtNum(row.currentprofit);
        },
        // 跳转到基金详情
        gotoDetail(val) {
            this.$util.toFundDetailPage(val.fundcode);
        },
        // 获取待处理协议列表
        async getSuitableList() {
            if (!this.$cache.getBinded()) {
                return;
            }
            const res = await userApi.getSuitableList();
            if (res.data) {
                this.warnNum = res.data.total;
                this.$store.commit("updateSuitableList", res.data.data);
                if (this.warnNum > 0) {
                    const showWarn = sessionStorage.getItem("_showWarn");
                    if (!showWarn) {
                        if (
                            this.$cache.getUserOtherInfo().specialflag == "0" &&
                            this.$util.getConfig().hideFunc
                        ) {
                            this.warnVisible = true;
                            sessionStorage.setItem("_showWarn", "1");
                            this.controlPopups();
                        }
                    }
                }
            }
        },
        // 关闭警告弹窗
        dialogClose() {
            this.warnVisible = false;
        },
        // 跳转到待处理协议列表
        toWarnDetail() {
            if (this.showclose === false) {
                this.appropriateHandlingVisible = true;
            } else {
                this.warnVisible = false;
                this.$router.push("/warnList");
            }
        },
        // 获取新一页数据
        newAssets(val) {
            this.pageoffset = val;
            this.doAction();
        },
        // 对基金频繁查询请求做处理
        doAction(val, cb) {
            const _this = this;
            if (cb) {
                val = this.$util.filterCode(val);
                this.searchText = val;
                if (val.length < 1) {
                    cb.call(this, []);
                    return false;
                }
            }
            clearTimeout(this.queryFind);
            this.queryFind = setTimeout(function () {
                _this.getAssets(val, cb);
            }, 500);
        },
        // 获取资产信息
        async getAssets(val, cb) {
            if (!this.$cache.getBinded() && !this.$cache.getCustnoCrm()) {
                return;
            }
            // const _x = {
            //     keyword: val ? val : (this.searchText ? this.searchText : ""),
            //     pagesize: cb ? 20 : this.pagecount,
            //     pagenum: val ? 1 : this.pageoffset,
            // };
            const res = await fundApi.getAssetsList({
                producttype: "@",
                sourceflag: this.sourceflag ? this.sourceflag : "",
                keyword: val || (this.searchText ? this.searchText : ""),
                pageSize: cb ? 20 : this.pagecount,
                pageNum: val ? 1 : this.pageoffset,
                assetshowtype: this.assetshowtype
            });
            this.hasLoad = true;
            if (res.data) {
                this.allAssets = res.data.first ? res.data.first : {};
                const array = res.data.returnList ? res.data.returnList : [];
                this.amountTypes[0].val = this.allAssets.totalasset;
                this.amountTypes[1].val = this.allAssets.lastprofit;
                this.amountTypes[2].val = this.allAssets.totalprofit;

                // 如果存在现金宝基金信息
                if (this.xjbFundInfo && this.xjbFundInfo.fundcode) {
                    const xjbFund = array.find(
                        (item) => item.fundcode === this.xjbFundInfo.fundcode
                    );
                    if (xjbFund) {
                        this.amountTypes[0].xjbMarketvalue = xjbFund.marketvalue || 0;
                    }
                }
                // 批量获取基金详细信息，包括 tradingmethod 字段
                if (array && array.length > 0) {
                    const fundCodeList = array.map((item) => item.fundcode);
                    const fundDetailRes = await fundApi.getFundLists({
                        fundcodelist: fundCodeList,
                        fundclass: "*",
                        pagesize: array.length,
                        pagenum: 1
                    });
                    
                    if (fundDetailRes.data && fundDetailRes.data.list) {
                        // 创建基金代码到详细信息的映射
                        const fundDetailMap = {};
                        fundDetailRes.data.list.forEach((detail) => {
                            fundDetailMap[detail.fundcode] = detail;
                        });
                        
                        // 合并 tradingmethod 字段到基金数据
                        array.forEach((fund) => {
                            if (fundDetailMap[fund.fundcode]) {
                                fund.tradingmethod = fundDetailMap[fund.fundcode].tradingmethod;
                            }
                        });
                    }
                }
                
                array.forEach((fund, index) => {
                    fund.isBuy = this.$util.checkBuy(fund);
                    fund.isSell = this.$util.checkSell(fund);
                    fund.isChange = this.$util.checkChange(fund);
                    fund.isCurrency = this.$util.checkGeneral(fund);
                });
                // 购买渠道选择了“全部”，且该客户存在直销+代销资产数据时
                const hasFlag1 = array.some((item) => item.sourceflag == "1");
                const hasFlag2 = array.some((item) => item.sourceflag == "2");
                this.dataPromptShow =
                    !this.sourceflag && hasFlag1 && hasFlag2 && this.showprofitexplain;
                if (!val) {
                    if (this.pageoffset == 1) {
                        this.curPage = 1;
                    }
                }
                this.assets = array;
                if (!cb) {
                    this.allPage = res.data.total ? res.data.total.toString() : "0";
                } else {
                    cb.call(this, array);
                }
            }
        },
        // 搜索资产
        searchAssets() {
            this.pageoffset = 1;
            this.doAction(this.searchText);
        },
        // 获取下拉列表数据
        querySearchAsync(queryString, cb) {
            this.pageoffset = 1;
            this.doAction(queryString, (res) => {
                let _cbArr = [];
                res.forEach((item, index) => {
                    let _x = {};
                    _x.value = item.fundname + "(" + item.fundcode + ")";
                    _x.id = item.fundcode;
                    _x.index = index;
                    _cbArr.push(_x);
                });
                cb(_cbArr);
            });
        },
        // 选中建议项
        handleSelect() {
            if (this.searchText.indexOf("(") != -1) {
                this.searchText = this.searchText.slice(0, this.searchText.indexOf("("));
            }
            this.pageoffset = 1;
            this.doAction();
        },
        // 切换资产类型
        selectType(index) {
            if (this.selectIndex != index) {
                this.selectIndex = index;
                this.pageoffset = 1;
                if (index == 0) {
                    // 全部产品
                    this.assetshowtype = 0;
                } else if (index == 1) {
                    // 钱柜产品
                    this.assetshowtype = 1;
                } else if (index == 2) {
                    // 普通产品
                    this.assetshowtype = 2;
                } else {
                    // 资产组合
                    this.$refs.comboAssets.getAssets();
                    return;
                }
                this.doAction();
            }
        },
        // 格式化涨跌幅数据
        formatterRate(rate) {
            if (!rate) {
                return "--";
            }
            const prefix = Number(rate) > 0 ? "+" : "";
            return prefix + this.$util.fmtNum(rate) + "%";
        },
        // 跳转到详情
        showDetail(item) {
            sessionStorage.setItem("_currentAsset", JSON.stringify(item));
            this.$router.push("/assetsDetail");
            this.$router.push({
                path: "/assetsDetail",
                query: {
                    sourceflag: this.sourceflag
                }
            });
        },
        // 点击申购或赎回按钮
        callbackFn(way, fund) {
            let moduleId = "";
            let flag = "0";
            if (way == "24" || way == "25") {
                moduleId = way;
            } else {
                if (fund.status == "1") {
                    moduleId = "20";
                } else {
                    moduleId = "22";
                }
            }
            if (moduleId == "20" || moduleId == "22" || moduleId == "36" || moduleId == "29") {
                flag = "0";
            } else {
                flag = "1";
            }
            // 申购 22 认购 20  转换36  赎回24  预约赎回25
            const _this = this;
            _this.$util.checkGtOcrModule(moduleId, flag, (res) => {
                _this.fundCon(way, fund);
            });
        },
        // 进一步操作
        fundCon(way, fund) {
            this.sdxFundInfo = {};
            const _this = this;
            if (way === "24" || way === "25") {
                let _url = "sellfund";
                if (way === "25") {
                    _url = "orderselllist";
                }
                const _fund = _this.$util.dataTaacFilter(fund);
                const _x = Object.assign({}, _fund, { way: way });
                sessionStorage.setItem("sellfund", JSON.stringify(_x));
                sessionStorage.setItem("_currentAsset", JSON.stringify(fund));
                // 现金宝取现
                if (fund.assetshowtype == "1") {
                    _url = "currencyredemption";
                }
                this.$router.push({ name: _url, query: { fundcode: fund.fundcode } });
            } else {
                // 购买
                if (way === "20,22") {
                    // 普通购买
                    fund.proto = "buy";
                    this.$util.fundRiskCheck(this, fund, (res) => {
                        if (res) {
                            _this.$util.getSdxProtocol(res, (data) => {
                                if (data) {
                                    const _x = Object.assign({}, data, { way: way });
                                    this.sdxFundInfo = _x;
                                    // 现金宝充值
                                    if (this.sdxFundInfo.assetshowtype == "1") {
                                        this.$router.push({
                                            name: "currencycharge",
                                            query: { fundcode: this.sdxFundInfo.fundcode }
                                        });
                                    } else {
                                        this.sdxDialogVisible = true;
                                        this.controlPopups();
                                    }
                                }
                            });
                        }
                    });
                }
            }
        },
        sdxDialogClose() {
            this.sdxDialogVisible = false;
        },
        sdxDialogContinue() {
            this.sdxDialogVisible = false;
            let _url = "buyfund";
            // // 现金宝充值
            // if (this.sdxFundInfo.assetshowtype == "1") {
            //     _url = "currencycharge";
            // }
            sessionStorage.setItem(_url, JSON.stringify(this.sdxFundInfo));
            this.$router.push({
                name: _url,
                query: { fundcode: this.sdxFundInfo.fundcode }
            });
        },
        // 登录后弹窗-银行卡
        bankCardListCheck(list) {
            this.bankCardNum = list.filter((item) => !item.activeDisabledTip).length;
            if (this.bankCardNum > 0) {
                const showBankCard = sessionStorage.getItem("_showBankCard");
                if (!showBankCard) {
                    if (
                        this.$cache.getUserOtherInfo().specialflag == "0" &&
                        this.$util.getConfig().hideFunc
                    ) {
                        this.bankCardVisible = true;
                        sessionStorage.setItem("_showBankCard", "1");
                        this.controlPopups();
                    }
                }
            }
        },
        bankCardListClose() {
            this.bankCardVisible = false;
        },
        bankCardListHandle() {
            this.bankCardVisible = false;
            this.$router.push({ name: "acctManager", query: { activeIndex: "4-1" } });
        },
        // 登录后弹窗-身份证生位
        idCardHolderCheck() {
            const info = this.$cache.getUser();
            if (
                info.certificatetype == "00" &&
                info.certificateno_eighteen &&
                info.certificateno_eighteen.length == 18
            ) {
                const showBankCard = sessionStorage.getItem("_showIdCardHolder");
                if (!showBankCard) {
                    this.idCardHolderVisible = true;
                    sessionStorage.setItem("_showIdCardHolder", "1");
                    this.controlPopups();
                }
            }
        },
        idCardHolderClose() {
            this.idCardHolderVisible = false;
        },
        async idCardHolderHandle() {
            let flag =
                this.$cache.getParamValue("account_info") &&
                this.$cache.getParamValue("account_info").needocrbiz &&
                this.$cache.getParamValue("account_info").needocrbiz.includes("certupgrade"); // 是否使用OCR上传方式升位
            if (flag && this.$cache.getSysParam("10301003").includes("A84")) {
                this.ocrShow = true;
            } else {
                const info = this.$cache.getUser();
                info.en_certificateno = info.en_certificateno_eighteen;
                const res = await userApi.updAcctInfo(info);
                if (res.data.appsheetserialno) {
                    this.$cache.refreshUser(() => {
                        this.idCardHolderVisible = false;
                        this.idCardHolderCompletedVisible = true;
                    });
                }
            }
        },
        // 登录后弹窗-身份证生位完成
        idCardHolderCompletedClose() {
            this.idCardHolderCompletedVisible = false;
        },
        idCardHolderCompletedHandle() {
            this.idCardHolderCompletedHandle = false;
            this.$router.push({ name: "idnumbertran" });
        },
        appropriateHandlingVisibleClose() {
            this.appropriateHandlingVisible = false;
        },
        // 控制弹框的优先级
        controlPopups() {
            if (this.idCardHolderVisible) {
                this.bankCardVisible = false;
                this.sdxDialogVisible = false;
                this.warnVisible = false;
                sessionStorage.setItem("_showWarn", "");
                sessionStorage.setItem("_showBankCard", "");
                sessionStorage.setItem("_showIdCardHolder", "");
            }
        },
        async imgUp(flag) {
            if (flag) {
                const info = this.$cache.getUser();
                const params = Object.assign({}, info);
                params.certificateno = flag.certificateno;
                delete params.en_certificateno;
                const res = await userApi.updAcctInfo(params, false, true);
                if (res.data.appsheetserialno) {
                    this.$cache.refreshUser(() => {
                        this.idCardHolderVisible = false;
                        this.idCardHolderCompletedVisible = true;
                    });
                }
            }
        },
        regression() {
            this.ocrShow = false;
        },
        // 查询投资者是否需要回访问卷
        openReturnVisit() {
            userApi.qryReturnVisitStatus().then(({ data }) => {
                if (data && data.data[0].returnvisitstatus == "0") {
                    const h = this.$createElement;
                    this.$msgbox({
                        title: "投资者回访",
                        message: h("p", null, [
                            h("p", null, "尊敬的投资者: "),
                            h(
                                "span",
                                { style: "margin-left: 20px" },
                                "根据《证券期货投资者适当性管理办法》关于定期对投资者开展回访的规定，诚邀您参与本次投资者回访调研工作，感谢您的支持!"
                            )
                        ]),
                        showCancelButton: true,
                        confirmButtonText: "现在参与",
                        cancelButtonText: "暂不"
                    }).then(async (action) => {
                        const res = await userApi.upReturnVisitStatus({
                            returnStatus: "1"
                        });
                        if (res.code == "0") {
                            window.open(this.$cache.getCompanyInfoParam("10102036"), "_blank");
                        }
                    });
                }
            });
        },
        handleCloseDialog() {
            this.appropriateHandlingVisible = false;
            this.warnVisible = false;
        }
    }
};
</script>

<style lang="scss" scoped>
@import "../../assets/css/varibles";
.assets-title {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin: 0 0 15px 0;
    .deadline-text {
        font-size: 14px;
        color: var(--color-text-accent);
        line-height: 25px;
    }
    .select-class {
        font-size: 14px;
        padding: 5px 15px;
        vertical-align: middle;
    }
    .assets-search {
        padding: 5px 0;
        .input-search {
            width: 350px;
            vertical-align: middle;
            .search-icon {
                margin: 3px 5px;
                color: var(--color-text-regular);
            }
            .el-input__inner {
                height: 40px;
                border-bottom-right-radius: 0;
                border-top-right-radius: 0;
            }
            .el-input-group__append {
                background-color: var(--color-primary);
                color: $text-color6;
                font-size: $f20;
                border-color: var(--color-primary);
                padding: 0 10px;
            }
        }
    }
}
.assets-info {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding-bottom: 16px;
    border-bottom: solid 1px var(--color-divided);

    .assets-item {
        width: 30%;
        height: 110px;
        border-radius: 6px;
        background: var(--color-bg-page);
        box-sizing: border-box;
        border: 1px solid var(--color-divided);
        // padding-top: 20px;
        padding-left: 32px;
        padding-right: 20px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        .assets-item-singn {
            display: flex;
            flex-direction: column;
        }
        .xjbAssets-item {
            display: flex;
            align-items: center;
            .assets-text {
                margin-left: 5px;
                margin-top: 25px;
                font-size: 16px;
                font-weight: 500;
                color: var(--color-text-primary);
            }
        }

        .amount-type {
            font-size: 14px;
            color: var(--color-text-primary);
            margin-bottom: 10px;
        }
        .assets-text {
            font-size: 32px;
            font-weight: 500;
            color: var(--color-text-primary);
        }
        .add {
            color: var(--color-up);
        }
        .reduce {
            color: var(--color-down);
        }
        .vertical-divider {
            width: 1px;
            height: 30px; /* 根据实际高度调整，或者使用100%但注意父元素高度 */
            background-color: var(--color-divided);
            margin: 0 10px; /* 左右留一些间距 */
        }
    }
}

.warn-info {
    background: var(--color-accent);
    box-sizing: border-box;
    border: 1px solid var(--color-divided);
    padding: 12px 15px;
    display: flex;
    .warn-icon {
        margin-top: 4px;
        color: var(--color-primary);
    }
    .warn-content {
        margin-left: 5px;
        font-size: 14px;
        line-height: 20px;
        color: var(--color-text-regular);
        .warn-tip {
            color: var(--color-primary);
        }
        .deal-btn {
            color: var(--color-redirect);
            cursor: pointer;
        }
    }
}

.warn-detail {
    padding: 50px 20px;
    font-size: 16px;
    text-align: center;
}

.asset-type {
    display: flex;
    padding: 16px 0px;
    text-align: center;
    line-height: 40px;
    font-size: 16px;

    .type-normal {
        width: 120px;
        height: 40px;
        border-radius: 25px;
        background: var(--color-bg-container);
        color: var(--color-text-regular);
        margin-right: 30px;
        cursor: pointer;
    }
    .type-select {
        width: 120px;
        height: 40px;
        border-radius: 25px;
        background: var(--color-primary);
        color: var(--color-text-white);
        margin-right: 30px;
        cursor: pointer;
    }
}
.btns {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 11px;
}
.line {
    background: var(--color-divided);
    width: 1px;
    height: 12px;
}
.fund-name {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    cursor: pointer;
    .xjbStyle {
        border: 1px solid var(--color-primary);
        color: var(--color-primary) !important;
        padding: 2px 5px;
    }
}
.el-table td.el-table__cell div {
    color: var(--color-text-primary);
}
.el-table td.el-table__cell span {
    color: var(--color-text-primary);
    &.add {
        color: var(--color-up);
    }
    &.reduce {
        color: var(--color-down);
    }
}
.el-table {
    border: 1px solid var(--color-divided);
}
.el-table--fit {
    margin-bottom: 20px;
}
.el-button.is-plain:hover,
.el-button.is-plain:focus,
.el-button.is-disabled.is-plain {
    background-color: transparent;
    border-color: transparent;
}
.el-button--text {
    font-size: 14px;
    font-weight: normal;
    color: var(--color-primary);
}
.el-button--text.is-disabled {
    color: var(--color-text-weak);
}
.page-box {
    padding: 0;
}
.el-pagination {
    margin-bottom: 0;
}
</style>
